import api from "../atlasApi";

export const serviceLogin = (data) => {
  return api.post("/auth/login/", data);
};

export const serviceGetUsers = (data) => {
  return api.post("/users/get-user/", data, {
    headers: {
      Authorization: "Token ea0bb95d88829a5174bae4657242c5c48e121228",
    },
  });
};

export const serviceAddUsers = (data) => {
  return api.post("/auth/register/", data, {});
};

export const serviceEditUsers = (data) => {
  return api.post("/users/edit-user/", data, {
    headers: {
      Authorization: "Token ea0bb95d88829a5174bae4657242c5c48e121228",
    },
  });
};

export const serviceAuthUsers = (data, token) => {
  return api.post("/auth/user/", data, {
    headers: {
      Authorization: "Token " + token,
    },
  });
};
